import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1, // 1 minute
      gcTime: 1000 * 60 * 2, // 2 minute
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: 1,
      onSuccess: () => {
        try {
          // invalidate payment status counts and lists after any mutation
          queryClient.invalidateQueries({ queryKey: ['GetPaymentStatusCounts'] }, { cancelRefetch: false })
          queryClient.invalidateQueries({ queryKey: ['ListPayments'] }, { cancelRefetch: false })
        } catch (error) {
          console.warn('Failed to clear cache', error)
        }
      },
    },
  },
})

export interface QueryClientProviderProps {
  children: ReactNode
}

export function CustomQueryClientProvider({ children }: QueryClientProviderProps) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default queryClient
